// Helpers for choosing the user identifier sent to third-party telemetry
// (Datadog RUM, Segment, Google Analytics). See SPD-5199.
//
// Under Auth0, @mqd/bootstrap maps `redsea_token` to the Auth0 access token (a bearer
// credential) and `userId` to the Auth0 subject. On genuine Redsea sessions,
// `redsea_token` is the Redsea user id. A JWT-shaped value must never leave the page.

// A JWT is three dot-separated base64url segments; its header always encodes to "eyJ".
const JWT_PATTERN = /^eyJ[A-Za-z0-9_-]*\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]*$/;

export const looksLikeJwt = (value) => typeof value === 'string' && JWT_PATTERN.test(value);

/**
 * Resolve the identifier to send to telemetry in place of `redsea_token`.
 *
 * - `redsea_token` is not JWT-shaped (genuine Redsea id, or missing): returned unchanged,
 *   so existing Redsea behavior is preserved exactly.
 * - `redsea_token` is JWT-shaped: the Auth0 subject is returned instead, if it is a
 *   non-empty, non-JWT string.
 * - Otherwise `null`: the caller must skip the call or omit the field.
 *
 * @param {?string} redseaToken  userStore.redsea_token
 * @param {?string} auth0Sub     userStore.userId (the Auth0 `sub` under Auth0)
 * @returns {{ id: ?string } | null}
 */
export const resolveTelemetryUserId = (redseaToken, auth0Sub) => {
  if (!looksLikeJwt(redseaToken)) return { id: redseaToken };
  if (typeof auth0Sub === 'string' && auth0Sub !== '' && !looksLikeJwt(auth0Sub)) {
    return { id: auth0Sub };
  }
  return null;
};
